<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Add to Schedule</p>
          </header>
          <section class="modal-card-body" style="height: 600px">
            <ValidationProvider
              v-slot="{ errors }"
              name="Title"
              rules="required"
            >
              <b-field
                class="has-margin-top-15"
                label="Title"
                :type="{ 'is-danger': errors.length > 0 }"
                :message="errors[0]"
              >
                <b-autocomplete
                  v-model="media.title"
                  placeholder="Select a title"
                  :data="filteredTitles"
                  field="title"
                  expanded
                  :open-on-focus="true"
                  @select="
                    (value) => {
                      if (value && value.id) {
                        selectedTitle = value
                      }
                    }
                  "
                />
              </b-field>
            </ValidationProvider>
            <BaseSelect
              v-if="selectedTitle && selectedTitle.media_type == 'series'"
              v-model="media.episode_id"
              label="Episode"
              :rules="'required'"
            >
              <option
                v-for="episode in episodes"
                :key="episode.id"
                :value="episode.id"
              >
                {{ episode.episode_number }}
                {{ episode.title ? `- ${episode.title}` : '' }}
              </option>
            </BaseSelect>
            <div class="columns is-multiline">
              <div class="column is-6">
                <BaseDateTimePicker
                  v-model="media.start_time"
                  @input="updateEndTime(media)"
                  label="Start Time"
                  :rules="'required'"
                >
                </BaseDateTimePicker>
              </div>
              <div class="column is-6">
                <BaseDateTimePicker
                  v-model="media.end_time"
                  label="End Time"
                  :rules="'required'"
                  :min-datetime="media.start_time"
                >
                </BaseDateTimePicker>
              </div>
              <div class="column is-12" v-if="!editingitem">
                <a href="#" @click.prevent="addAdditionalSlots"
                  >Add Additional Slots</a
                >
              </div>
            </div>
            <div
              class="columns"
              v-for="(item, index) in media.additional"
              v-if="!editingitem"
              :key="index"
            >
              <div class="column is-5">
                <BaseDateTimePicker
                  v-model="item.start_time"
                  @input="updateEndTime(item)"
                  label="Start Time"
                  :rules="'required'"
                >
                </BaseDateTimePicker>
              </div>
              <div class="column is-5">
                <BaseDateTimePicker
                  v-model="item.end_time"
                  label="End Time"
                  :rules="'required'"
                  :min-datetime="item.start_time"
                >
                </BaseDateTimePicker>
              </div>
              <div class="column is-2 has-padding-top-50">
                <a href="" @click.prevent="removeAdditional(index)"
                  ><b-icon icon="close"></b-icon
                ></a>
              </div>
            </div>
            <b-field v-if="!editingitem" class="has-margin-top-10">
              <b-checkbox v-model="repeat">Repeat?</b-checkbox>
            </b-field>
            <BaseSelect
              v-if="repeat"
              v-model="frequency"
              label="Frequency"
              :rules="'required'"
            >
              <option value="daily">Same time Daily</option>
              <option value="daily-selected">
                Same time Daily (Selected Days only)
              </option>
              <option value="weekly">Same day and time Weekly</option>
            </BaseSelect>
            <BaseSelect
              v-if="
                repeat && selectedTitle && selectedTitle.media_type == 'series'
              "
              v-model="episoderepeat"
              label="Repeat episodes"
              :rules="'required'"
            >
              <option value="same">Same Episode</option>
              <option value="following">Following Episodes</option>
            </BaseSelect>
            <BaseInput
              v-if="
                repeat &&
                ((selectedTitle &&
                  selectedTitle.media_type === 'series' &&
                  episoderepeat === 'same') ||
                  (selectedTitle && selectedTitle.media_type === 'movie'))
              "
              v-model="repeatnumber"
              label="Number of Repeats"
              type="number"
              rules="required"
            />
            <div v-if="frequency === 'daily-selected'">
              <b-field
                class="has-margin-top-10"
                label="Repeat Certain Days only?"
              >
                <div>
                  <b-checkbox v-model="repeatdays" :native-value="1"
                    >Mon</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="2"
                    >Tue</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="3"
                    >Wed</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="4"
                    >Thu</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="5"
                    >Fri</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="6"
                    >Sat</b-checkbox
                  >
                  <b-checkbox v-model="repeatdays" :native-value="0"
                    >Sun</b-checkbox
                  >
                </div>
              </b-field>
              <div>
                <a @click.prevent="selectAllDays" class="has-margin-right-10"
                  >Select All</a
                >
                <a @click.prevent="unselectAllDays">Unselect All</a>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              :loading="loading"
              @click.prevent="passes(save)"
            >
              {{ editingitem ? 'Update' : 'Add' }}
            </button>
            <button
              v-if="editingitem"
              class="button is-info is-pulled-right"
              :loading="loading"
              @click.prevent="createCopy"
            >
              Copy
            </button>
            <button
              v-if="editingitem && editingitem.repeats_id"
              class="button is-info is-pulled-right"
              :loading="loading"
              @click.prevent="editSequence"
            >
              Edit Sequence
            </button>
            <button
              v-if="editingitem"
              class="button is-info is-pulled-right has-margin-right-5"
              :loading="loading"
              @click.prevent="confirmDelete"
            >
              Delete
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
    <EditSequenceModal
      v-if="item"
      :repeats-id="item.repeats_id"
      :channel-id="channelId"
      :show="showEditSequenceModal"
      @close-modal="showEditSequenceModal = false"
      @refresh="
        $emit('refresh')
        showModal = false
        $emit('close-modal')
      "
    >
    </EditSequenceModal>
  </b-modal>
</template>

<script>
import { sortBy } from 'lodash'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import BaseSelect from '@/components/BaseSelect'
import EditSequenceModal from '@/components/EditSequenceModal'
import MediaChannelApi from '@/api/mediaChannels'
import EpisodesApi from '@/api/episodes'
import ScheduleApi from '@/api/schedules'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import addMinutes from 'date-fns/addMinutes'

export default {
  name: 'AddToScheduleModal',
  components: {
    BaseDateTimePicker,
    BaseSelect,
    EditSequenceModal,
  },
  mixins: [Filters, Utils],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    channelId: {
      type: Number,
      default: null,
    },
    start: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      showEditSequenceModal: false,
      loading: false,
      initialized: false,
      showModal: this.show,
      selectedTitle: {},
      repeat: false,
      frequency: '',
      episoderepeat: '',
      editingitem: this.item,
      media: {
        start_time: this.start || new Date(),
        end_time: new Date(),
        episode_id: undefined,
        additional: [],
      },
      episodes: [],
      repeatdays: [],
      repeatnumber: '',
    }
  },
  computed: {
    filteredTitles() {
      if (this.media && this.media.title) {
        let filter = this.media.title.toLowerCase()
        return this.titles.filter((item) =>
          item.title.toLowerCase().includes(filter)
        )
      }
    },
  },
  watch: {
    show() {
      this.showModal = this.show
    },
    async selectedTitle(newVal, oldVal) {
      if (this.selectedTitle && this.selectedTitle.media_type === 'series') {
        let episodes = await EpisodesApi.getAllByMediaId(this.selectedTitle.id)
        episodes.forEach(
          (episode) =>
            (episode.episode_number = parseInt(episode.episode_number, 10))
        )
        this.episodes = sortBy(episodes, 'episode_number')
        if (!this.editingitem) {
          this.media.episode_id = undefined
        }
      }
      if (
        this.selectedTitle &&
        this.selectedTitle.mediadata &&
        this.media.start_time
      ) {
        let mediaData = JSON.parse(this.selectedTitle.mediadata)
        if (mediaData && mediaData.mediaLength) {
          this.media.end_time = this.media.start_time.addMinutes(
            parseInt(mediaData.mediaLength, 10)
          )
          if (this.media.additional && this.media.additional.length > 0) {
            this.media.additional.forEach((item) => {
              item.end_time = item.start_time.addMinutes(
                parseInt(mediaData.mediaLength, 10)
              )
            })
          }
          this.$forceUpdate()
        }
      }
    },
    'media.episode_id': function (newVal, oldVal) {
      this.setEpisode()
    },
    'media.start_time': function (newVal, oldVal) {
      if (
        this.selectedTitle &&
        this.selectedTitle.media_type === 'movie' &&
        this.selectedTitle.mediadata
      ) {
        let mediaData = JSON.parse(this.selectedTitle.mediadata)
        if (mediaData && mediaData.mediaLength) {
          this.media.end_time = this.media.start_time.addMinutes(
            parseInt(mediaData.mediaLength, 10)
          )
        }
      } else if (
        this.media.episode_id &&
        this.selectedTitle.media_type === 'series'
      ) {
        let episode = this.episodes.find(
          (item) => item.id === this.media.episode_id
        )
        if (episode && episode.episode_data) {
          let episodedata = JSON.parse(episode.episode_data)
          if (episodedata.episodeLength) {
            this.media.end_time = this.media.start_time.addMinutes(
              parseInt(episodedata.episodeLength, 10)
            )
          }
        }
      }
    },
  },
  async created() {
    let titles = await MediaChannelApi.getByChannelId(this.channelId)
    titles.forEach((item) => {
      let mediadata = null
      if (item.mediadata) {
        mediadata = JSON.parse(item.mediadata)
      }
      item.title =
        item.title +
        (item.media_type === 'series' && mediadata && mediadata.seriesNo
          ? ` S${mediadata.seriesNo}`
          : '') +
        ` - ${this.$options.filters.capitalize(item.media_type)}`
    })
    this.titles = titles
    if (this.editingitem) {
      const found = this.titles.find(
        (item) => item.id === this.editingitem.media_id
      )
      if (found) {
        this.selectedTitle = found
        this.media = {
          id: this.editingitem.id,
          start_time: this.editingitem.start,
          end_time: this.editingitem.end,
          title: found.title,
          episode_id: this.editingitem.episode_id,
        }
      }
    }
    this.initialized = true
  },
  methods: {
    editSequence() {
      this.showEditSequenceModal = true
    },
    updateEndTime(item) {
      if (
        this.selectedTitle &&
        this.selectedTitle.media_type === 'movie' &&
        this.selectedTitle.mediadata
      ) {
        let mediaData = JSON.parse(this.selectedTitle.mediadata)
        if (mediaData && mediaData.mediaLength) {
          item.end_time = item.start_time.addMinutes(
            parseInt(mediaData.mediaLength, 10)
          )
        }
      } else if (
        this.media.episode_id &&
        this.selectedTitle.media_type === 'series'
      ) {
        let episode = this.episodes.find(
          (item) => item.id === this.media.episode_id
        )
        if (episode && episode.episodedata) {
          let episodedata = JSON.parse(episode.episodedata)
          if (episodedata.episodeLength) {
            item.end_time = item.start_time.addMinutes(
              parseInt(episodedata.episodeLength, 10)
            )
          }
        }
      }
    },
    removeAdditional(index) {
      this.media.additional.splice(index, 1)
    },
    async createCopy() {
      try {
        this.loading = true
        this.editingitem.channel_id = this.channelId
        this.editingitem.media_id = this.selectedTitle.id
        this.editingitem.start_time = this.editingitem.start
        this.editingitem.end_time = this.editingitem.end
        this.editingitem.copy = true
        delete this.editingitem.id
        await ScheduleApi.add(this.editingitem)
        this.$buefy.toast.open({
          message: 'Schedule updated successfully!',
          position: 'is-top',
          type: 'is-success',
        })
        this.loading = false
        this.$emit('refresh')
        this.closeModal()
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Error saving schedule',
          position: 'is-top',
          type: 'is-danger',
        })
        this.loading = false
      }
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this item?',
        onConfirm: async () => {
          this.loading = true
          await ScheduleApi.remove(this.media)
          this.$buefy.toast.open({
            message: 'Schedule item removed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
          this.$emit('refresh')
          this.closeModal()
        },
      })
    },
    setEpisode() {
      if (this.media.episode_id) {
        let episode = this.episodes.find(
          (item) => item.id === this.media.episode_id
        )
        if (episode && episode.episodedata) {
          let episodedata = JSON.parse(episode.episodedata)
          if (episodedata.episodeLength) {
            this.media.end_time = this.media.start_time.addMinutes(
              parseInt(episodedata.episodeLength, 10)
            )
            if (this.media.additional && this.media.additional.length > 0) {
              this.media.additional.forEach((item) => {
                item.end_time = item.start_time.addMinutes(
                  parseInt(episodedata.episodeLength, 10)
                )
              })
            }
          }
        }
      }
    },
    async save() {
      try {
        this.media.channel_id = this.channelId
        this.media.media_id = this.selectedTitle.id

        if (this.editingitem) {
          await ScheduleApi.update(this.media)
        } else {
          this.media.repeat = this.repeat
          this.media.frequency = this.frequency
          this.media.episoderepeat = this.episoderepeat
          this.media.repeatdays = this.repeatdays
          this.media.repeatnumber = this.repeatnumber
            ? parseInt(this.repeatnumber, 10)
            : undefined
          await ScheduleApi.add(this.media)
          this.$buefy.toast.open({
            message: 'Schedule updated successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
          this.$emit('refresh')
          this.closeModal()
        }
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message:
            err.status === 409
              ? 'There is a schedule clash with another program with the same timeslot. Please update the time to a different available timeslot.'
              : 'Error saving schedule',
          position: 'is-top',
          type: 'is-danger',
        })

        this.loading = false
      }
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
    selectAllDays() {
      this.repeatdays = [0, 1, 2, 3, 4, 5, 6]
    },
    unselectAllDays() {
      this.repeatdays = []
    },
    addAdditionalSlots() {
      if (this.media.additional.length === 0) {
        this.media.additional.push({
          start_time: this.media.start_time,
          end_time: this.media.end_time,
        })
      } else {
        let lastItem = this.media.additional[this.media.additional.length - 1]
        this.media.additional.push({
          start_time: lastItem.start_time,
          end_time: lastItem.end_time,
        })
      }
    },
  },
}
</script>
